import { render } from "./achievement-box.vue?vue&type=template&id=8b44ae04&scoped=true"
import script from "./achievement-box.vue?vue&type=script&lang=js"
export * from "./achievement-box.vue?vue&type=script&lang=js"

import "./achievement-box.vue?vue&type=style&index=0&id=8b44ae04&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b44ae04"]])

export default __exports__